/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react"
import { User } from "../types/user.type"
import { httpGet } from "../services/Http.service"
import { AxiosResponse } from "axios"
import { apiUrl } from "../configs/config.constants"

export function useGetProfile() {
  const [profiles, setProfiles] = useState<User[]>([])
  const [attendedBy, setAttendedBy] = useState<User[]>([])
  const [performedServices, setPerformedServices] = useState<User[]>([])

  function getProfile() {
    httpGet(apiUrl.user.list)
      .then((response: AxiosResponse<User[]>) => {
        setProfiles(response.data)
      })
      .catch((error: any) => {
        console.error(error)
      })
  }

  function getAttendedBy() {
    httpGet(apiUrl.service.attendedBy)
      .then((response: AxiosResponse<User[]>) => {
        const allAttendedBy = response.data
        const performedServices = allAttendedBy.filter((attendedBy: User) => attendedBy.performService)
        setAttendedBy(allAttendedBy)
        setPerformedServices(performedServices)
      })
      .catch((error: any) => {
        console.error(error)
      })
  }

  return {
    getProfile,
    profiles,
    getAttendedBy,
    attendedBy,
    performedServices,
  }
}
